import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Sidebar, TabType } from './Sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
import { TAB_TO_PATH } from '../routes';

export const Layout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [shareToast, setShareToast] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const activeTab = (Object.keys(TAB_TO_PATH) as TabType[]).find(
    (tab) => TAB_TO_PATH[tab] === location.pathname
  ) || (location.pathname === '/blog' ? 'blog' : 'calculator');

  const handleNavigateToTab = (tab: string) => {
    const path = TAB_TO_PATH[tab] || '/';
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-100 font-sans selection:bg-emerald-500 selection:text-zinc-950">
      <Sidebar
        activeTab={activeTab as TabType}
        onSelectTab={(tab) => handleNavigateToTab(tab)}
        isMobileOpen={mobileMenuOpen}
        onCloseMobile={() => setMobileMenuOpen(false)}
      />

      <div className="lg:pl-64 flex flex-col min-h-screen">
        <TopBar
          onQuickPreset={(salary) => navigate(`/?salary=${salary}`)}
          onShare={() => {
            navigator.clipboard.writeText(window.location.href);
            setShareToast(true);
            setTimeout(() => setShareToast(false), 2500);
          }}
          onOpenMobileMenu={() => setMobileMenuOpen(true)}
        />

        {shareToast && (
          <div className="fixed bottom-6 right-6 z-50 bg-zinc-900 text-white px-4 py-3 rounded-2xl shadow-2xl border border-zinc-700 flex items-center gap-2.5 animate-bounce text-xs font-bold">
            <Check className="w-4 h-4 text-emerald-400" />
            <span>Calculator link copied to clipboard!</span>
          </div>
        )}

        <main className="flex-1 w-full px-4 sm:px-6 lg:px-8 py-6 sm:py-8 space-y-8">
          <Outlet />
        </main>

        <Footer onNavigateToTab={handleNavigateToTab} />
      </div>
    </div>
  );
};
